<template>
  <div class="project-wrap">
    <Header />
        <div class="title-wrap">
          <div class="title">
            案例中心
           <br> (Case Center)</div>
        </div>
    <div class="product-list">
      <div class="product-list-item" v-for="(item, index) in projects" :key="index" @click="goDetail(item)">
        <img :src="item.image" alt="" class="image">
        <div class="name">{{item.name}}</div>
        <div class="name">{{item.english}}</div>
      </div>
    </div>
    <Bottom />
  </div>
</template>

<script>
import Header from '@/views/mobile/components/Header'
import Bottom from '@/views/mobile/components/Bottom'
import {projects} from "@/assets/project";
export default {
  name: "Project",
  components: {Header, Bottom},
  data () {
    return {
      projects
    }
  },
  methods: {
    goDetail (item) {
      this.$router.push({
        path: '/mb_projectDetail',
        query: {
          id: item.id
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.project-wrap {
  width: 100%;
  .title-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    .title {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      width: 80%;
      padding: 0.4rem;
      margin-top: 0.4rem;
      font-size: 0.7rem;
      font-weight: 700;
      letter-spacing: 0.1rem;
      border: 1px solid #19adeb;
      border-radius: 0.5rem;
      color: #3a8ee6;
      box-shadow: 0 0.1rem 0.2rem #88daf2;
      text-shadow: 0.02rem 0.02rem 0.02rem #888888, -0.02rem -0.02rem 0.05rem #FFFFFF;
    }
  }
  .product-list {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 1rem;
    .product-list-item {
      margin-top: 0.4rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .image {
        width: 80%;
        height: 6rem;
        margin-bottom: 0.08rem;
      }
      .name {
        font-size: 0.36rem;
      }
    }
  }
}
</style>
